export const CODESNIPPET = {
    BasicStructureCode1: `public class HelloWorld {
    public static void main(String[] args) {
        System.out.println("Hello, World!");                         
    }
}`,
    PrintStatementsCode1: `System.out.println("Hello");
System.out.println("World");`,
    PrintStatementsOutput1: `Hello
World`,
    PrintStatementsCode2: `System.out.print("Java is ");
System.out.print("awesome!");`,
    PrintStatementsOutput2: `Java is awesome!`,
    PrintStatementsCode3: `System.out.println("This is text.");`,
    PrintStatementsOutput3: `This is text.`,
    PrintStatementsCode4: `System.out.println(123);`,
    PrintStatementsOutput4: `123`,
    PrintStatementsCode5: 'System.out.println(10 + 5);',
    PrintStatementsOutput5: `15`,
    CommentsCode1: `// This is a single-line comment
System.out.println("Hello, World!"); // Prints Hello, World!`,
    CommentsCode2: `/*
This is a multi-line comment.
It can span several lines and is often used
for more detailed explanations or temporary notes.
*/
System.out.println("Hello, World!");`,
    IdentationCode1: `public class Main {
public static void main(String[] args) {
System.out.println("Hello, world!");if (true) {
System.out.println("This is indented incorrectly.");
}
}
}`,
    IdentationCode2: `public class Main {
    public static void main(String[] args) {
        System.out.println("Hello, world!");
        if (true) {
            System.out.println("This is indented correctly.");
        }
    }
}`,
    IdentationInJavaCode1: `public void exampleMethod() {
    if (true) {
        System.out.println("Indented block");
    }
}`,
    IdentationInJavaCode2: `public class Main {
    public static void main(String[] args) {
        System.out.println("Hello, world!");
    }
}`,



}